module.exports = __webpack_public_path__ + "static/media/27OCHA17.f9beeb51.jpg";